"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpAdapter = void 0;
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var Types_1 = require("./Types");
var HttpAdapter = /** @class */ (function () {
    function HttpAdapter(options) {
        if ((0, lodash_1.isNil)(options.productId)) {
            throw new Error(Types_1.ConfigurationErrors.MissingProductIdError);
        }
        if ((0, lodash_1.isNil)(options.locale)) {
            throw new Error(Types_1.ConfigurationErrors.MissingLocaleError);
        }
        this.httpLibrary = axios_1.default;
        this.options = options;
    }
    return HttpAdapter;
}());
exports.HttpAdapter = HttpAdapter;
//# sourceMappingURL=HttpAdapter.js.map